<template>
  <el-form-item class="preview-form_item"
                :class="[ formType, `form-label_${textAlign}`]"
                :style="{'padding-left': paddingLeft}"
                :prop="variableName"
                :rules="rules">
    <!-- 左侧标签 -->
    <span class="form-item_label_left"
          slot="label"  
          v-show="labelPosition=='left'"
          :style="{ 
            minWidth: labelWidth,
            textAlign: textAlign
          }">{{labelText}}</span>
    <!-- 表单项内容 -->
    <slot class="form-item_content"></slot>
    <!-- 右侧标签 -->
    <span class="form-item_label_right"
          v-if="labelPosition=='right'"
          :style="{ 
            minWidth: labelWidth,
            textAlign: textAlign
          }">{{labelText}}</span>
  </el-form-item>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    //  标签文本内容
    labelText: {
      type: String,
      default: ""
    },
    //  标签宽度
    labelWidth: {
      type: String,
      default: ""
    },
    //  标签位置(相对于表单项内容)
    labelPosition: {
      type: String,
      default: "left"
    },
    //  标签文本对齐(标签文本相对于标签宽度)
    textAlign: {
      type: String,
      default: "left"
    },
    //  表单项类型
    formType: {
      type: String,
      default: ""
    },
    //  表单项绑定变量名称
    variableName: {
      type: String,
      default: ""
    },  
    //  表单项校验规则
    rules: {
      type: [Array, Object],
      default: () => ({})
    },
    // 左间距
    paddingLeft: {
      type: String,
      default: ''
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/base_package/PreviewFormItem.vue